import { Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { ToastError, ToastSuccess, ToastWarning } from "../toaster/toast.utils";
import DefaultModal from "./DefaultModal";

export interface ForgotResult {
  newPassword?: string;
}
interface Props {
  open: boolean;
  onClose: () => void;
  currentEmail: string;
  onComplete: (result: ForgotResult) => void;
}

const FirstAccessModal: React.FC<Props> = ({
  open,
  onClose,
  currentEmail,
  onComplete
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleResetPassword = async () => {
    if (password !== confirmPassword) {
      ToastWarning("As senhas não coincidem.");
      return;
    }

    try {
      await api.post(`/user/create-pass`, {}, { params: { password, email } });
      onComplete({ newPassword: password });
      ToastSuccess("Senha redefinida com sucesso!");
      onClose();
    } catch (error: any) {
      ToastError(`Erro ao redefinir a senha: ${error.message}`);
    }
  };

  useEffect(() => {
    if (open) {
      setEmail(currentEmail);
      setPassword("");
      setConfirmPassword("");
    }
  }, [open]);

  const renderStep = () => {
    return (
      <>
        <TextField
          label="Nova senha"
          type="password"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          label="Confirmar senha"
          type="password"
          fullWidth
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Button fullWidth variant="contained" onClick={handleResetPassword}>
          Redefinir Senha
        </Button>
      </>
    );
  };

  return (
    <DefaultModal open={open} onClose={onClose} title="Recuperação de Senha">
      {renderStep()}
    </DefaultModal>
  );
};

export default FirstAccessModal;
